import { Component, ChangeDetectionStrategy, ViewChild, signal } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { PaymentMethod } from '@pedix-workspace/utils';

@Component({
    selector: 'app-coupon-validation-invalid-payment-method-dialog',
    templateUrl: './coupon-validation-invalid-payment-method-dialog.component.html',
    styleUrls: ['./coupon-validation-invalid-payment-method-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent]
})
export class CouponValidationInvalidPaymentMethodDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  paymentMethodsForCoupon = signal<PaymentMethod[]>([]);

  get paymentMethodsForCouponList() {
    return this.paymentMethodsForCoupon()
      ?.map(pm => pm.name)
      .join(', ');
  }

  open(paymentMethodsForCoupon: PaymentMethod[]) {
    this.paymentMethodsForCoupon.set(paymentMethodsForCoupon);

    return this.modalDialog.open();
  }
}
